<template>
  <div class="lg:py-12 md:py-12 py-5 lg:w-8/12 md:w-10/12 w-11/12 mx-auto">
    <div class="contaner mx-auto">
      <swiper class="swiper" :options="swiperOptions">
        <swiper-slide v-for="(item, index) in quotes.data" :key="index">
          <div class="lg:flex md:flex gap-4">
            <div class="relative lg:w-2/5 md:w-2/5 w-full">
              <img
                :src="`${$imageURL}/${item.image}`"
                alt="New"
                class="hw-300px rounded-lg contain"
              />
            </div>
            <div class="lg:w-3/5 md:w-3/5 w-full flex flex-col justify-between">
              <div class="lg:px-4 md:px-4 lg:pt-0 md:pt-0 pt-2">
                <h6
                  class="fsize20 sm-fsize16 font-semibold text-primary overflow-wrap"
                >
                  {{ item.title }}
                </h6>
              </div>
              <div
                class="flex lg:justify-end md:justify-end lg:m-3 m-2 lg:mt-0 md:mt-0 mt-4"
                v-if="item.link"
              >
                <a :href="item.link" target="_blank">
                  <div class="flex items-center gap-1 cursor-pointer">
                    <feather-icon
                      icon="ArrowUpRightIcon"
                      class="text-primary flex border-primary rounded-icons"
                      svgClasses="w-4 h-4"
                    />
                    <p class="text-primary fsize14 sm-fsize12">View</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>

  <!-- <div class="lg:py-20 md:py-12 py-5 lg:w-7/12 md:w-10/12 w-11/12 mx-auto">
    <div class="contaner mx-auto">
      <swiper class="swiper" :options="swiperOptions">
        <swiper-slide v-for="(item, index) in quotes.data" :key="index">
          <div class="relative">
            <img
              :src="`${$imageURL}/${item.image}`"
              alt="New"
              class="w-full lg:h-[500px] md:h-[400px] h-[350px] rounded-lg object-cover"
            />
            <div
              class="flex items-center justify-end absolute top-1/2 right-0 transform -translate-y-1/2 lg:h-72 h-52"
            >
              <div class="lg:w-1/2 md:w-8/12 w-full lg:px-0 md:px-3 px-4">
                <h6 class="fsize20 sm-fsize16 font-semibold">
                  {{ item.title }}
                </h6>
              </div>
            </div>
            <div class="absolute bottom-0 right-0 lg:m-3 m-2">
              <a :href="item.link" target="_blank">
                <div class="flex items-center gap-1 cursor-pointer">
                  <feather-icon
                    icon="ArrowUpRightIcon"
                    class="text-primary flex border-primary rounded-icons"
                    svgClasses="w-4 h-4"
                  />
                  <p class="text-primary fsize14 sm-fsize12">View</p>
                </div>
              </a>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div> -->
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      images: [
        {
          image:
            "https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg",
          text: "Caregiver Saathi is the culmination of the personal life experiences of its founder, Bhavana Issar.",
        },
        {
          image:
            "https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg",
          text: "Caregiver Saathi is the culmination of the personal life experiences of its founder, Bhavana Issar.",
        },
        {
          image:
            "https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg",
          text: "Caregiver Saathi is the culmination of the personal life experiences of its founder, Bhavana Issar.",
        },
      ],
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
      },
    };
  },

  computed: {
    ...mapState("quotes", {
      quotes: "quotes",
    }),
  },
  async mounted() {
    await this.$store.dispatch("quotes/get_quotes");
    console.log("quotes", this.quotes);
  },
};
</script>
